<nav class="container-fluid">
  <div class="py-3">
    <div class="d-flex justify-content-between align-items-center">
      <a class="topbar-brand d-flex"
         [ngClass]="(isRouteBySimpleFlow$ | async) ? 'invisible' : 'visible'"
         [routerLink]="['/']">
        <ng-container *ngTemplateOutlet="logo"></ng-container>
      </a>
      <ng-container *ngIf="!isLoggedIn">
        <div class="btn-group d-none d-sm-flex">
          <a class="nav-link py-0 px-3"
             (click)="openSignInPopup(); false"
             href="#"
             [translate]="'SHARED.LINKS.SIGN-IN.TEXT'">
          </a>
          <a class="nav-link py-0 ps-3 pe-0"
             (click)="goToCreateAccount(); false"
             href="#"
             [translate]="'SHARED.LINKS.SIGN-UP.TEXT'"></a>
        </div>
        <div class="btn-group d-flex d-sm-none"
             dropdown>
          <a id="menu-button"
             aria-pressed="false"
             href="#"
             (click)="false;"
             dropdownToggle>
            <i-feather name="menu"
                       class="menu-icon"></i-feather>
          </a>
          <ul id="dropdown-unlogged"
              *dropdownMenu
              class="dropdown-menu dropdown-menu-right"
              role="menu"
              aria-labelledby="menu-button">
            <li *ngIf="!isLoggedIn"
                role="menuitem">
              <a href="#"
                 class="dropdown-item"
                 (click)="openSignInPopup(); false">
                <i-feather name="log-in"
                           class="me-3">
                </i-feather>
                <span [translate]="'SHARED.LINKS.SIGN-IN.TEXT'"></span>
              </a>
            </li>
            <li *ngIf="!isLoggedIn"
                role="menuitem">
              <a href="#"
                 class="dropdown-item"
                 (click)="goToCreateAccount(); false">
                <i-feather name="user-plus"
                           class="me-3">
                </i-feather>
                <span [translate]="'SHARED.LINKS.SIGN-UP.TEXT'"></span>
              </a>
            </li>
          </ul>
        </div>
      </ng-container>
      <ng-container *ngIf="isLoggedIn">
        <div class="btn-group"
             dropdown>
          <a id="menu-button"
             aria-pressed="false"
             href="#"
             (click)="false;"
             dropdownToggle>
            <i-feather name="menu"
                       class="menu-icon"></i-feather>
          </a>
          <ul id="dropdown-logged-in"
              *dropdownMenu
              class="dropdown-menu dropdown-menu-right"
              role="menu"
              aria-labelledby="menu-button">
            <li role="menuitem"
                *ngIf="isLoggedIn">
              <a [routerLink]="['account']"
                 class="dropdown-item">
                <i-feather name="user"
                           class="me-3"></i-feather>
                <span>{{ userName }}</span>
              </a>
            </li>
            <li role="menuitem">
              <a [routerLink]="['account/visits']"
                 class="dropdown-item">
                <i-feather name="calendar"
                           class="me-3"></i-feather>
                <span [translate]="'SHARED.LINKS.MY-VISITS.TEXT'">
                </span>
              </a>
            </li>
            <li role="menuitem">
              <a href="#"
                 (click)="onChangePassword(); false"
                 class="dropdown-item">
                <i-feather name="key"
                           class="me-3"></i-feather>
                <span [translate]="'SHARED.LINKS.PASSWORD-CHANGE.TEXT'">
                </span>
              </a>
            </li>
            <li class="divider dropdown-divider"></li>
            <li role="menuitem">
              <a href="#"
                 class="dropdown-item"
                 (click)="signOut(); false">
                <i-feather name="log-out"
                           class="me-3">
                </i-feather>
                <span [translate]="'SHARED.LINKS.SIGN-OUT.TEXT'"></span>
              </a>
            </li>

          </ul>
        </div>
      </ng-container>
    </div>
  </div>
</nav>

<ng-template #logo>
  <svg id="logo-bjootify"
       xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 440.7 123.8">
    <path class="color1"
          d="M61.2 56.5c3.4 4.1 5.1 9.3 5.1 15.8 0 8-2.5 14.2-7.6 18.5-5.1 4.3-11.5 6.5-19.4 6.5H2.7c-.7 0-1.3-.3-1.9-.8-.5-.5-.8-1.1-.8-1.9V7.3c0-.7.3-1.3.8-1.9s1.2-.8 1.9-.8h35.6c7.1 0 12.7 2 16.9 6.1 4.2 4.1 6.4 9.5 6.4 16.4 0 4.9-1.2 9.4-3.7 13.4s-5.9 6.8-10.3 8.3c5.6 1.1 10.2 3.7 13.6 7.7zm-10-41.9C48 11.5 43.5 10 37.6 10h-32v37.2h32c5.5-.1 9.9-1.9 13.3-5.4C54.3 38.3 56 33.4 56 27c.1-5.2-1.5-9.3-4.8-12.4zM54.6 87c4.1-3.3 6.1-8.2 6.1-14.8 0-6.5-2-11.5-6.1-14.8-4.1-3.3-9.4-5-16-5h-33V92h33c6.6 0 11.9-1.7 16-5zM70.9 122.8c-.4-.4-.7-1-.7-1.7v-.3c0-.6.2-1.2.7-1.7.4-.5 1-.8 1.7-.9 3.4-.5 6.5-1.9 9.1-4.1 2.6-2.2 3.9-5.3 3.9-9.3v-71c0-.7.2-1.3.7-1.9.5-.5 1.1-.8 1.9-.8s1.4.3 1.9.8.7 1.1.7 1.9V105c0 3.7-1 7-2.9 9.8-1.9 2.8-4.3 5-7.1 6.5s-5.5 2.3-8.1 2.3c-.8-.1-1.4-.3-1.8-.8zm14-104c-.8-.8-1.3-1.8-1.3-3v-1.1c0-1.2.4-2.3 1.3-3 .9-.8 2-1.2 3.4-1.2 1.2 0 2.3.4 3.1 1.2.8.8 1.3 1.8 1.3 3v1.1c0 1.2-.4 2.3-1.3 3-.8.8-1.9 1.2-3.2 1.2-1.4 0-2.5-.4-3.3-1.2zM175.7 81.6C172.9 86.9 169 91 164 94c-5 3-10.5 4.6-16.6 4.6s-11.6-1.5-16.6-4.6c-5-3-8.9-7.2-11.8-12.5-2.9-5.3-4.3-11.2-4.3-17.6 0-6.5 1.4-12.4 4.3-17.7 2.9-5.3 6.8-9.5 11.7-12.5 4.9-3 10.5-4.6 16.7-4.6 6.1 0 11.6 1.5 16.6 4.6 5 3 8.9 7.2 11.7 12.5 2.8 5.3 4.2 11.2 4.2 17.7.1 6.6-1.3 12.5-4.2 17.7zm-4.5-32.9c-2.3-4.5-5.6-8.1-9.7-10.7-4.1-2.6-8.8-3.9-14-3.9-5.1 0-9.8 1.3-14 3.9-4.2 2.6-7.5 6.2-9.9 10.7-2.4 4.5-3.6 9.6-3.6 15.2s1.2 10.6 3.6 15.1 5.7 8.1 9.9 10.7c4.2 2.6 8.8 3.9 14 3.9 5.2 0 9.9-1.3 14-3.8 4.1-2.6 7.4-6.1 9.7-10.7 2.3-4.5 3.5-9.6 3.5-15.2s-1.2-10.7-3.5-15.2zM253.7 81.6C250.9 86.9 247 91 242 94c-5 3-10.5 4.6-16.6 4.6s-11.6-1.5-16.6-4.6c-5-3-8.9-7.2-11.8-12.5-2.9-5.3-4.3-11.2-4.3-17.6 0-6.5 1.4-12.4 4.3-17.7 2.9-5.3 6.8-9.5 11.7-12.5 4.9-3 10.5-4.6 16.7-4.6 6.1 0 11.6 1.5 16.6 4.6 5 3 8.9 7.2 11.7 12.5 2.8 5.3 4.2 11.2 4.2 17.7 0 6.6-1.4 12.5-4.2 17.7zm-4.6-32.9c-2.3-4.5-5.6-8.1-9.7-10.7-4.1-2.6-8.8-3.9-14-3.9-5.1 0-9.8 1.3-14 3.9-4.2 2.6-7.5 6.2-9.9 10.7-2.4 4.5-3.6 9.6-3.6 15.2s1.2 10.6 3.6 15.1c2.4 4.5 5.7 8.1 9.9 10.7 4.2 2.6 8.8 3.9 14 3.9 5.2 0 9.9-1.3 14-3.8 4.1-2.6 7.4-6.1 9.7-10.7 2.3-4.5 3.5-9.6 3.5-15.2s-1.1-10.7-3.5-15.2zM301.6 31.5c.5.5.8 1.1.8 1.7 0 .7-.2 1.3-.7 1.8-.5.5-1.1.7-1.8.7h-14.6v47.1c0 3.9.7 6.5 2.1 7.7 1.4 1.3 3.1 1.9 5.2 1.9.4 0 .9-.1 1.5-.3.7-.2 1.2-.3 1.7-.3.6 0 1.1.2 1.6.7.4.5.7 1 .7 1.7 0 .8-.5 1.5-1.6 2.1-1.1.6-2.3.9-3.7.9-2.2 0-4.1-.2-5.6-.5s-3.1-1.5-4.7-3.6-2.4-5.4-2.4-10.1V35.7h-10.9c-.6 0-1.2-.3-1.7-.8s-.8-1.1-.8-1.7c0-.7.2-1.3.7-1.8.5-.5 1.1-.7 1.8-.7H280V13.9c0-.7.3-1.3.8-1.9.5-.5 1.1-.8 1.9-.8.8 0 1.4.3 1.9.8s.7 1.1.7 1.9v16.8h14.6c.6 0 1.2.3 1.7.8zM316.4 18.9c-.8-.8-1.3-1.8-1.3-3v-1.1c0-1.2.4-2.3 1.3-3 .9-.8 2-1.2 3.4-1.2 1.2 0 2.3.4 3.1 1.2.8.8 1.3 1.8 1.3 3v1.1c0 1.2-.4 2.3-1.3 3-.8.8-1.9 1.2-3.2 1.2-1.4 0-2.5-.4-3.3-1.2zm5.2 77.6c-.5.5-1.1.8-1.9.8-.8 0-1.4-.3-1.9-.8s-.7-1.1-.7-1.9V31.8c0-.7.3-1.3.8-1.9s1.1-.8 1.9-.8c.8 0 1.4.3 1.9.8s.7 1.1.7 1.9v62.9c0 .7-.3 1.3-.8 1.8zM372.9 32.8c.5.5.7 1.1.7 1.8s-.2 1.3-.7 1.8c-.5.5-1.1.7-1.8.7h-15.6v57.6c0 .7-.3 1.3-.8 1.9-.5.5-1.1.8-1.9.8-.8 0-1.4-.3-1.9-.8s-.7-1.1-.7-1.9V37.1h-10.6c-.6 0-1.2-.3-1.7-.8s-.8-1.1-.8-1.7c0-.8.2-1.4.7-1.9.5-.4 1.1-.7 1.8-.7h10.6V15.9c0-5.2 1.4-9.2 4.2-11.8 2.8-2.7 6.3-4 10.7-4 2.2 0 4.3.3 6.3.9 2 .6 3 1.5 3 2.8 0 .7-.3 1.3-.8 1.9-.5.5-1.1.8-1.7.8-.7 0-1.6-.2-2.8-.7-2-.6-3.5-.9-4.5-.9-2.7 0-4.9.9-6.6 2.8-1.6 1.9-2.4 4.6-2.4 8.3v16h15.6c.6 0 1.2.3 1.7.8zM440 29.9c.5.5.7 1.1.7 1.9v59c0 6.6-1.3 12.4-4 17.4-2.7 5-6.4 8.8-11.1 11.5-4.7 2.7-10.1 4-16.1 4-3.9 0-7.4-.5-10.7-1.4-3.2-.9-5.9-2.1-8.1-3.6-1.6-1.1-2.1-2.3-1.5-3.6.6-1.1 1.4-1.6 2.3-1.6.4 0 .8.1 1.2.4 2.1 1.3 4.7 2.5 7.6 3.5 3 1 6.1 1.5 9.5 1.5 5 0 9.5-1.2 13.4-3.6 3.9-2.4 6.9-5.7 9.1-10 2.2-4.3 3.2-9.2 3.2-14.6v-6c-2 4-5.3 7.3-9.7 9.9-4.5 2.6-9.1 3.9-13.8 3.9-7.9 0-13.9-2.3-17.7-6.8-3.9-4.5-5.8-10.8-5.8-18.7V31.8c0-.7.2-1.3.7-1.9.5-.5 1.1-.8 1.9-.8s1.4.3 1.9.8.7 1.1.7 1.9v41.3c0 13.7 6.1 20.5 18.3 20.5 3.8 0 7.5-1 11.2-3 3.7-2 6.6-4.6 8.9-7.7 2.3-3.2 3.4-6.4 3.4-9.8V31.8c0-.7.2-1.3.7-1.9.5-.5 1.1-.8 1.9-.8.8 0 1.4.3 1.9.8z" />
    <path class="color2"
          d="M48.3 116.6H2.7c-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7h45.6c1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7z" />
  </svg>
</ng-template>
